import type { AssetTypeSaveBarProps } from "./asset-type-save-bar.type";

import AppSaveBar from "@/modules/app-save-bar";

import "./asset-type-save-bar.style.less";

const AssetTypeSaveBar = ({
  onCancel,
  onSave,
  lastUpdatedAt,
  loading,
}: AssetTypeSaveBarProps) => {
  return (
    <div className="asset-type-save-bar">
      <AppSaveBar
        date={lastUpdatedAt}
        onSave={onSave}
        onCancel={onCancel}
        loading={loading}
      />
    </div>
  );
};

export default AssetTypeSaveBar;
